import { useCallback, useEffect, useRef, useState } from 'react'
import { GrFormPrevious, GrFormNext } from 'react-icons/gr'
import { Link, useParams } from 'react-router-dom'
import axiosClient from '../../../config/axios-client'
import { useTranslation } from 'react-i18next'

import HomeFutureMineralsCountriesSilder from './HomeFutureMineralsCountriesSilder'
import HomeFutureMineralsCountriesSilderLoading from './HomeFutureMineralsCountriesSilderLoading'

export default function HomeFutureMineralsCountriesSection() {
  const { lng } = useParams()
  const { t } = useTranslation()
  const futureMineralsCountriesSliderRef = useRef(null)

  const [minerals, setMinerals] = useState(null)
  const [isLoading, setIsLoading] = useState(true)
  const [selectedMineralCategoryId, setSelectedMineralCategoryId] = useState(0)

  const handleOnChangeMineralCategoryId = useCallback((id) => {
    setSelectedMineralCategoryId((prevId) => (id === prevId ? 0 : id))
  }, [])

  const handleNavigation = useCallback(
    (direction) => {
      const adjustment = lng === 'en' ? (direction === 1 ? '+1' : '-1') : direction === 1 ? '-1' : '+1'
      futureMineralsCountriesSliderRef.current.splide.go(adjustment)
    },
    [lng],
  )

  const getFutureMineralsRegionHome = useCallback(() => {
    setIsLoading(true)
    axiosClient
      .get('/platform/minerals/region/home')
      .then(({ data }) => {
        setMinerals(data.minerals)
      })
      .catch((error) => { })
      .finally(() => {
        setIsLoading(false)
      })
  }, [])

  useEffect(() => {
    getFutureMineralsRegionHome()
  }, [getFutureMineralsRegionHome])

  return (
    <div className="bg-light">
      <div className="app-container px-8 py-16 lg:px-0">
        <div className="flex flex-col gap-4">
          <div
            data-aos="fade-down"
            className="flex flex-col justify-between gap-2 md:flex-row md:items-center md:gap-2"
          >
            <h2 className="text-2xl font-black">{t('FUTURE_MINERALS_REGION')}</h2>
            <div className="flex items-center justify-between gap-4">
              <div className="flex items-center gap-2">
                <button
                  onClick={() => handleOnChangeMineralCategoryId(1)}
                  title={t('CLEAN_ENERGY_MINERALS')}
                  className={`flex items-center border-2 p-2 outline-none ${selectedMineralCategoryId === 1 ? 'bg-muted-300 border-cleanEnergy' : 'border-muted-300 hover:bg-muted-300 bg-white hover:border-cleanEnergy'}`}
                >
                  <img
                    src="/assets/icons/clean-energy-color/clean-energy-icon.svg"
                    alt=""
                    className="h-5 w-5"
                  />
                </button>
                <button
                  onClick={() => handleOnChangeMineralCategoryId(2)}
                  title={t('INDUSTRIAL_MINERALS')}
                  className={`flex items-center border-2 p-2 outline-none ${selectedMineralCategoryId === 2 ? 'bg-muted-300 border-industrial' : 'border-muted-300 hover:bg-muted-300 bg-white hover:border-industrial'}`}
                >
                  <img
                    src="/assets/icons/industrial-color/industrial-icon.svg"
                    alt=""
                    className="h-5 w-5"
                  />
                </button>
                <button
                  onClick={() => handleOnChangeMineralCategoryId(4)}
                  title={t('FOOD_SECURITY_MINERALS')}
                  className={`flex items-center border-2 p-2 outline-none ${selectedMineralCategoryId === 4 ? 'bg-muted-300 border-security' : 'border-muted-300 hover:bg-muted-300 bg-white hover:border-security'}`}
                >
                  <img
                    src="/assets/icons/security-color-green/security-food-icon.svg"
                    alt=""
                    className="h-5 w-5"
                  />
                </button>
              </div>
              <div className="flex items-center gap-2">
                <button
                  onClick={() => handleNavigation(1)}
                  aria-label={t('NEXT')}
                  className="hover:border-secondary-600 border-muted-300 flex items-center border-2 bg-white p-2 hover:bg-light ltr:rotate-180"
                >
                  <GrFormNext className="h-5 w-5" />
                </button>
                <button
                  onClick={() => handleNavigation(-1)}
                  aria-label={t('PREVIOUS')}
                  className="hover:border-secondary-600 border-muted-300 flex items-center border-2 bg-white p-2 hover:bg-light ltr:rotate-180"
                >
                  <GrFormPrevious className="h-5 w-5" />
                </button>
                <Link
                  title={t('MORE')}
                  to={`/${lng}/future-minerals/region`}
                  className="hover:border-secondary-600 border-muted-300 flex select-none items-center border-2 bg-white px-3 py-1.5 hover:bg-light"
                >
                  {t('MORE')}
                </Link>
              </div>
            </div>
          </div>
          <div data-aos="fade-up">
            {isLoading ? (
              <HomeFutureMineralsCountriesSilderLoading />
            ) : (
              <HomeFutureMineralsCountriesSilder
                minerals={minerals}
                selectedMineralCategoryId={selectedMineralCategoryId}
                futureMineralsCountriesSliderRef={futureMineralsCountriesSliderRef}
              />
            )}
          </div>
        </div>
      </div>
    </div>
  )
}
